import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Epic%20cinematic%20night%20sky%20with%20countless%20stars%2C%20milky%20way%20galaxy%2C%20deep%20space%20background%20with%20warm%20golden%20and%20amber%20nebula%20highlights%2C%20atmospheric%20cosmic%20photography%2C%20professional%20astrophotography%20quality%2C%20no%20text%20no%20people&width=1920&height=1080&seq=xk-hero-bg&orientation=landscape"
        alt="星空传媒 - 高清影视平台"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background-950/40 via-background-950/25 to-background-950/70"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/20 backdrop-blur-sm border border-accent-500/30 mb-6">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-sparkling-2-line text-accent-400 text-sm"></i>
            </div>
            <span className="text-sm text-accent-300 font-medium whitespace-nowrap">海量高清资源 · 每日更新</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-4">
            星空传媒
            <span className="block text-xl md:text-2xl lg:text-3xl font-medium text-background-200 mt-2">
              在线免费观看 · 全集高清资源
            </span>
          </h1>

          <p className="text-base md:text-lg text-background-300 max-w-xl mx-auto mb-8 leading-relaxed">
            汇聚星空传媒全系列高清视频，无需下载、无需注册，随时随地免费在线播放。海量剧集持续更新，画质清晰流畅。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/drama"
              className="px-8 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors shadow-lg shadow-primary-500/25 whitespace-nowrap cursor-pointer"
            >
              <span className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-play-circle-fill"></i>
                </div>
                立即观看
              </span>
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/25 text-background-50 font-semibold text-sm hover:bg-background-50/25 transition-colors whitespace-nowrap cursor-pointer"
            >
              <span className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-information-line"></i>
                </div>
                了解更多
              </span>
            </Link>
          </div>

          <div className="flex items-center justify-center gap-8 mt-10">
            {[
              { value: '50,000+', label: '视频资源' },
              { value: '8,000万+', label: '月活跃用户' },
              { value: '99.9%', label: '播放成功率' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">
                  {stat.value}
                </p>
                <p className="text-xs md:text-sm text-background-400 mt-1 whitespace-nowrap">
                  {stat.label}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-8 h-8 flex items-center justify-center">
          <i className="ri-arrow-down-s-line text-background-50/60 text-xl"></i>
        </div>
      </div>
    </section>
  );
}